import { EventMembershipStatuses } from "@api/enums/EventMembershipStatuses";
import { EventMembershipTypes } from "@api/enums/EventMembershipTypes";
import {UserProfile} from "./UserProfile";

export interface MembershipsCreateParams {
    model: {
        eventSchemaId: string;
        eventObjectId: string;
        status: EventMembershipStatuses;
        type: EventMembershipTypes;
    };
    userIds: number[];
}

export class EventMembership extends UserProfile {

    constructor(data: any) {
        super(data);
        // Object.assign(this, data);
    }
}